import React, { useEffect, useState, useMemo} from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import QuickView from "../containers/QuickView/QuickView";
import CartPopUp from "../containers/Cart/CartPopUp";
import { useDeviceType } from "../helper/useDeviceType";
import { connect } from "react-redux";
import ReadMore from "../components/Truncate/Truncate";
import PageLoader from "../components/PageLoader/PageLoader";
import { CloseIcon, CartIcon, Minus, Plus, ShoppingCartIcon, CartBuy} from "../components/AllSvgIcon";
import { cartAnimation } from "../helper/cart-animation";
import { useCart } from "../contexts/cart/use-cart";
import { useFavorites } from "../contexts/favorites/use-favorites";
import Button from "react-bootstrap/Button";
import PartnerHome from "../containers/PartnerHome/PartnerHome";
import { Counter } from "../components/Counter/Counter";
import { QuantityModifier } from "../components/QuantityModifier/QuantityModifier";
import { AuthContext } from "../contexts/auth/auth.context";
import { SearchContext } from "../contexts/search/search.context";
import "./product-info.css";
import {
  productCategory,
  ProductModalData,
  ResetModalData,
  searchSuggestions,
  searchStoreProduct,
  getProductsMappedwithSubCat,
  getProductsMappedwithCat,
  getProductOutOfStock,
  getProductOutOfStockCat,
  getProductBrands,
  getProductFilterBrands,
  getSortProductsName,
  getSortProductsPrice,
  sortByNameProduct,
  resetPage,
  changePage,
  getRelatedProducts,
  changeRelatedProductPage,
  resetRelatedProductPage
} from "../store/actions/productAction";
import {
  getPartnerPages,
  oosModified,
  // resetPage,
  // changePage
} from "../store/actions/globalAction";
import { fetchCart } from "../store/actions/cartAction";
import Sidebar from "../containers/Sidebar/Sidebar";
import Products from "../containers/Products/Products";
import StoreNav from "../components/StoreNav/StoreNav";
import storeType from "../constants/storeType";
import SubscribeOur from "../components/SubscribeOur/SubscribeOur"
import {
  MainContentArea,
  SidebarSection,
  ContentSection,
  OfferSection,
  MobileCarouselDropdown,
} from "../styled/pages.style";
import { compDate, isTodayApplicable, baseUrl } from "../constants/Constant";
import LazyLoad from "react-lazyload";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Spinner from 'react-bootstrap/Spinner';
import Carousel from "react-multi-carousel";
import Brand from "../components/Brand/Brand";
import t from '../i18n/translate';
import itemToCartService from "../services/itemToCartService";
import expressService from "../services/expressService";
import SimpleMessageDialog from "../components/SimpleMessageDialog/SimpleMessageDialog";
import RelatedProduct from "../components/RelatedProduct/RelatedProduct";
import { FavoriteContainer } from "../components/ProductCard/ProductCard.style";
import { Button as MButton } from "@material-ui/core";
import { Favorite, FavoriteBorder, Tune, CardGiftcard, ErrorOutline, DeleteOutlined } from "@material-ui/icons";
import FlagIconFactory from 'react-flag-icon-css';
import { logAddToCart, logAddToWishlist, logRemoveFromCart, logRemoveFromWishlist, logViewItem, logSeenEventView } from "../services/googleAnalytics";
import DietaryPreferences from "../components/DietaryPreferences";
import ProductDetailSkeleton from "../components/Skeleton/ProductDetailSkeleton";
const FlagIcon = FlagIconFactory(React, { useCssModules: false });

const ProductData = (props, { userAgent }) => {
  let mql = window.matchMedia("all and (min-width: 769px)");
  let mqs = window.matchMedia("all and (max-width: 768px)");
  const deviceType = useDeviceType(userAgent);
  const cartType = "normal";
  const history = useHistory();
  const { pid } = props.props.match.params;
  const {
    addItemToCart,
    addItem,
    removeItem,
    removeItemFromCart,
    updateItem,
    isInCart,
    getItem,
    fetchOrderItems,
    cartclose,
    resetCart
  } = useCart();
  const { fetchFavorites } = useFavorites();
  const { state, searchdispatch } = React.useContext(SearchContext);
  const targetRef = React.useRef(null);
  const PAGE_TYPE = "grocery";
  const {
    authState: { isAuthenticated },
    authDispatch,
  } = React.useContext(AuthContext);
  const lang = localStorage.getItem('lang') || 'en';
  const [sliderIndex, setSliderIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

	// Properly construct images array with comprehensive error handling
	const images = useMemo(() => {
		const imageList = [];

		// Debug: Log raw API data
		console.log('🔍 Product Modal Data:', {
			hasModalData: !!props.modalData,
			defaultImage: props.modalData?.default_image_url,
			sliders: props.modalData?.store_item_sliders,
			sliderCount: props.modalData?.store_item_sliders?.length || 0
    });

		// Add default/main image if it exists and is valid
		if (props.modalData?.default_image_url &&
			typeof props.modalData.default_image_url === 'string' &&
			props.modalData.default_image_url.trim() !== '') {
			imageList.push(props.modalData.default_image_url);
			console.log('✅ Added default image:', props.modalData.default_image_url);
		} else {
			console.warn('⚠️ No valid default image found');
		}

		// Add slider images if they exist
		if (props.modalData?.store_item_sliders) {
			if (Array.isArray(props.modalData.store_item_sliders)) {
				props.modalData.store_item_sliders.forEach((imageSlider, index) => {
					// Validate each slider object and its image_url
					if (imageSlider &&
						typeof imageSlider === 'object' &&
						imageSlider.image_url &&
						typeof imageSlider.image_url === 'string' &&
						imageSlider.image_url.trim() !== '') {

						// Avoid duplicates
						if (!imageList.includes(imageSlider.image_url)) {
							imageList.push(imageSlider.image_url);
							console.log(`✅ Added slider image ${index + 1}:`, imageSlider.image_url);
						} else {
							console.log(`⚠️ Skipped duplicate image ${index + 1}`);
						}
					} else {
						console.warn(`⚠️ Invalid slider at index ${index}:`, imageSlider);
					}
				});
			} else {
				console.error('❌ store_item_sliders is not an array:', props.modalData.store_item_sliders);
			}
		} else {
			console.log('ℹ️ No store_item_sliders found in API response');
		}

		console.log(`📸 Final image list (${imageList.length} images):`, imageList);

		// Return array with at least one fallback image
		return imageList.length > 0 ? imageList : [require('../assets/images/delishop-favicons.png')];
	}, [props.modalData?.default_image_url, props.modalData?.store_item_sliders]);

  window.onbeforeunload = () => {
    cartclose();
  };

  // Simple Message Dialog
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showHeaderDialog, setShowHeaderDialog] = useState(false);
  const [isConfirmButton, setIsConfirmButton] = useState(false);
  const [confirmLabel, setConfirmLabel] = useState('OK');
  const [dialogLoading, setDialogLoading] = useState(false);
  const [closeLabel, setCloseLabel] = useState('CLOSE');
  const [dialogHeaderLabel, setDialogHeaderLabel] = useState('Error');
  const [errorLog, setErrorLog] = useState(null);
  const [simpleDialogBackdrop, setSimpleDialogBackdrop] = useState(true);
  const [isSpinning, setIsSpinning] = useState(true)
  const [isLoadingAPI, setIsLoadingAPI] = useState(false)
  const [showFilter, setShowFilter] = useState(false);
	const [showZoomModal, setShowZoomModal] = useState(false);
	const [zoomImageIndex, setZoomImageIndex] = useState(0);
	const [zoomLevel, setZoomLevel] = useState(1);
	const [isPanning, setIsPanning] = useState(false);
	const [panPosition, setPanPosition] = useState({x: 0, y: 0});
	const [startPan, setStartPan] = useState({x: 0, y: 0});
	const [lastTap, setLastTap] = useState(0);
	const [pinchDistance, setPinchDistance] = useState(0);
	const [lastZoomLevel, setLastZoomLevel] = useState(1);
	const [isTransitioning, setIsTransitioning] = useState(false);

  const stepperLoadingRef = React.useRef(false);
  const [justRemovedFromCart, setJustRemovedFromCart] = useState(false);
  const [justRemovedRedeemItem, setJustRemovedRedeemItem] = useState(false);

  // Delipoints state
  const [dpBalance, setDpBalance] = useState(0);
  const [isDisplayDelipoints, setIsDisplayDelipoints] = useState(false);
  const [showRedeemTooltip, setShowRedeemTooltip] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(baseUrl + 'api/v1/delipoints/customer/current', {
      headers: { Authorization: token }
    })
      .then(r => r.json())
      .then(resp => {
        if (resp.success && resp.data) {
          setDpBalance(resp.data.dpBalance ?? 0);
          setIsDisplayDelipoints(((resp.data.dpBalance ?? 0) > 0) && resp.data.dpBalance >= props.modalData.dp_points);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    props.fetchCart({ type: 0 });
  }, []);

  // localStorage.setItem("viewProductType", "product_detail")
  // localStorage.setItem("viewProductId", props.modalData.item_id)
  
  const openFilterModal = () => {
    setShowFilter(!showFilter)
  }

  let itemQ = getItem(props.modalData.item_id)?.quantity;
  const redeemQuantity = getItem(props.modalData.item_id)?.dp_redeem_quantity ?? null;
  const itemNormalQty = (itemQ ?? 0) - (redeemQuantity ?? 0);
  const [itemQuantity, setItemQuantity] = useState(1);

  const {
    addItemToFavorites,
    removeItemFromFavorites,
    isInFavorites,
  } = useFavorites();
  
  function getItemQuantity(q) {
    if (q === undefined || q === 0) {
      return 1;
    } else {
      return q;
    };
  };

  useMemo(() => {
    setItemQuantity(getItemQuantity(itemQ));
  }, [itemQ]);


  const handleAddRemoveFavorite = (e) => {
    e.stopPropagation();
    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
      document.getElementById("joinBTn").click();
      window.trigger = "add to favorites"
    } else {
      let query = { type: cartType === "express" ? 1 : 0, item_id: props.modalData.item_id };
      if (isInFavorites(props.modalData.item_id)) {
        removeItemFromFavorites(query);
        logRemoveFromWishlist(props.modalData)
      } else {
        addItemToFavorites(query);
        logAddToWishlist(props.modalData)
      }      
    }

  };

  const handleAddClick = async (e) => {
    e.stopPropagation();
    setIsLoading(true);

    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
      document.getElementById("joinBTn").click();
      setIsLoading(false);
    } else {
      // setIsLoading(true);
      // let itemQuantity = 1;
      // // If user click on button [Add to cart]
      // if (!isInCart(props.modalData.item_id)) {
        // cartAnimation(e);
      // }
      // // if user click on button increase item quantity
      // else {
      //   itemQuantity = getItem(props.modalData.item_id).quantity + 1;
      // }

      cartAnimation(e);

      const freshCart = await fetchOrderItems(cartType);
      const freshItem = freshCart?.data?.orderdata?.order_item_details?.find(
        (i) => i.item_id === props.modalData.item_id
      );
      if (freshItem && (freshItem.dp_redeem_quantity ?? 0) > 0) {
        await itemToCartService.removeItemFromCart(freshItem, cartType);
      }

      const itemResp = await itemToCartService.addItem(props.modalData.item_id, cartType, 1, 0, 0, redeemQuantity ?? 0, false);
      if (itemResp.success) {
        setJustRemovedFromCart(false);
        logAddToCart(itemResp.data);
        fetchOrderItems(cartType);
      }
      else {
        if (typeof itemResp.error === 'string' && itemResp.error === "multiSupplier") {
          setIsConfirmButton(true);
          setConfirmLabel(t('shop_add_item_to_cart_different_shop_error_remove'));
          setCloseLabel(t('shop_add_item_to_cart_different_shop_error_cancel'));
          setDialogHeaderLabel(t('shop_add_item_to_cart_different_shop_error_title'));
          setShowHeaderDialog(true);
          setErrorLog({
            error: true,
            error_type: 'multiSupplier'
          });
        }
        else if (itemResp.error && itemResp.data.type === "paymentInProgress") {
          setIsConfirmButton(true);
          setConfirmLabel(t('shop_popup_continue_payment_button'));
          setCloseLabel(t('shop_popup_cancel_payment_button'));
          setDialogHeaderLabel(t('shop_popup_payment_locked_label'));
          setShowHeaderDialog(true);
          setErrorLog({ error: true, error_type: 'paymentInProgress' });
          setSimpleDialogBackdrop('static');
        }
        else {
          setErrorLog({ error: false });
        }
        setErrorMessage(itemResp.message);
        setShowError(true);
      }
      setIsLoading(false);
    };
  };



  const closeSimpleDialog = async () => {
    if (errorLog.error && errorLog.error_type === 'paymentInProgress') {
      setDialogLoading(true);
      const orderLockResp = await expressService.orderLocked(cartType);
      if (orderLockResp.status === 200) {
        setTimeout(async () => {
          const itemResp = await itemToCartService.addItem(props.modalData.item_id, cartType, 1, 0, 0, redeemQuantity ?? 0, false);

          if (itemResp.success) {
            await fetchOrderItems(cartType);
          }
          else {
            setErrorMessage(itemResp.message);
          }
  
          setShowError(false);
          setDialogLoading(false);
        }, 250);
      }
      else {
        alert(t('shop_item_update_error'));
        setShowError(false);
        setDialogLoading(false);
      }
    }
    else {
      setShowError(false);
    }
  };
  
  const handleOverWriteCart = async () => {
    setDialogLoading(true);
  
    await resetCart();
  
    setTimeout(async () => {
      const itemResp = await itemToCartService.addItem(props.modalData.item_id, cartType, 1, 0, 0, redeemQuantity ?? 0, false);

      if (itemResp.success) {
        logAddToCart(itemResp.data)
        await fetchOrderItems(cartType);
      }
      else {
        setErrorMessage(itemResp.message);
      }
  
      setShowError(false);
      setDialogLoading(false);
    }, 250);
  };

  const onConfirm = () => {
    if (errorLog.error && errorLog.error_type === 'multiSupplier') {
      handleOverWriteCart();
    }
    else if (errorLog.error && errorLog.error_type === 'paymentInProgress') {
      history.push("/checkout");
    }
  };

  /**
   * Shared API call for redeem quantity changes.
   * newQty=0 removes the redeem; newQty>0 sets the redeemed quantity.
   */
  const callRedeemAPI = async (e, newQty) => {
    setIsLoading(true);

    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
      document.getElementById("joinBTn").click();
      setIsLoading(false);
      return;
    }

    let itemResp;
    if (itemNormalQty === 0 && newQty === 0) {
      itemResp = await itemToCartService.removeItemFromCart(getItem(props.modalData.item_id), cartType);
    } else {
      itemResp = await itemToCartService.addItem(
        props.modalData.item_id,
        cartType,
        itemNormalQty,  // normal units only (total - dp_redeem_quantity)
        0,              // confirm
        1,              // is_redeem_payment
        newQty,         // dp_redeem_quantity (independent of regular qty)
        false           // is_auto_apply_redeem_quantity
      );
    }

    if (itemResp.success) {
      if (newQty === 0) {
        setJustRemovedRedeemItem(true);
      } else {
        setJustRemovedRedeemItem(false);
      }
      if (newQty > (redeemQuantity ?? 0)) {
        logAddToCart(itemResp.data);
      } else if (newQty < (redeemQuantity ?? 0)) {
        logRemoveFromCart(itemResp.data);
      }
      fetchOrderItems(cartType);
    } else {
      if (typeof itemResp.error === 'string' && itemResp.error === "multiSupplier") {
        setIsConfirmButton(true);
        setConfirmLabel(t('shop_add_item_to_cart_different_shop_error_remove'));
        setCloseLabel(t('shop_add_item_to_cart_different_shop_error_cancel'));
        setDialogHeaderLabel(t('shop_add_item_to_cart_different_shop_error_title'));
        setShowHeaderDialog(true);
        setErrorLog({ error: true, error_type: 'multiSupplier' });
      } else if (itemResp.error && itemResp.data?.type === "paymentInProgress") {
        setIsConfirmButton(true);
        setConfirmLabel(t('shop_popup_continue_payment_button'));
        setCloseLabel(t('shop_popup_cancel_payment_button'));
        setDialogHeaderLabel(t('shop_popup_payment_locked_label'));
        setShowHeaderDialog(true);
        setErrorLog({ error: true, error_type: 'paymentInProgress' });
        setSimpleDialogBackdrop('static');
      } else {
        setErrorLog({ error: false });
      }
      setErrorMessage(itemResp.message);
      setShowError(true);
    }

    setIsLoading(false);
  };

  // Initial redeem click — adds first redeemed unit
  const handleRedeemClick = async (e) => {
    e.stopPropagation();
    if (itemQuantity !== itemQ) cartAnimation(e);
    await callRedeemAPI(e, 1);
  };

  // Stepper: add one more redeemed unit (limited only by dp balance)
  const handleRedeemIncrease = async (e) => {
    e.stopPropagation();
    await callRedeemAPI(e, redeemQuantity + 1);
  };

  // Stepper: remove one redeemed unit (0 clears the redeem entirely)
  const handleRedeemDecrease = async (e) => {
    e.stopPropagation();
    await callRedeemAPI(e, redeemQuantity - 1);
  };

  const handleRemoveClick = async (e) => {
    e.stopPropagation();
    let itemResp = null;

    if (!localStorage.getItem("user")) {
      document.getElementById("joinBTn").click();
    }
    else {
      stepperLoadingRef.current = true;
      setIsLoading(true);
      if (itemNormalQty === 1 && (redeemQuantity ?? 0) === 0) {
        itemResp = await itemToCartService.removeItemFromCart(getItem(props.modalData.item_id), cartType);
        if (itemResp.success) {
          setJustRemovedFromCart(true);
          fetchOrderItems(cartType);
        } else {
          setShowError(true);
          setErrorMessage(itemResp.message);
        }
      } else {
        const newNormalQty = itemNormalQty - 1;
        itemResp = await itemToCartService.addItem(props.modalData.item_id, cartType, newNormalQty, 0, 0, redeemQuantity ?? 0, false);
        if (itemResp.success) {
          if (newNormalQty === 0) setJustRemovedFromCart(true);
          fetchOrderItems(cartType);
        } else {
          setShowError(true);
          setErrorMessage(itemResp.message);
        }
      }
      stepperLoadingRef.current = false;
      setIsLoading(false);
    }
  };

	const handleClickSliderImage = (index) => {
		// Validate index is within bounds
		if (index >= 0 && index < images.length) {
			console.log(`🖼️ Switching to image ${index + 1}/${images.length}`);
			setSliderIndex(index);
		} else {
			console.error(`❌ Invalid image index: ${index} (available: 0-${images.length - 1})`);
			setSliderIndex(0); // Reset to first image
		}
	}

	const handleImageClick = (index) => {
		setZoomImageIndex(index);
		setShowZoomModal(true);
		setZoomLevel(1);
		setPanPosition({x: 0, y: 0});
	}

	const handleCloseZoomModal = () => {
		setShowZoomModal(false);
		setZoomLevel(1);
		setPanPosition({x: 0, y: 0});
		setIsPanning(false);
	}

	const handleNextImage = () => {
		setIsTransitioning(true);
		setZoomImageIndex((prev) => (prev + 1) % images.length);
		setZoomLevel(1);
		setPanPosition({x: 0, y: 0});
	}

	const handlePrevImage = () => {
		setIsTransitioning(true);
		setZoomImageIndex((prev) => (prev - 1 + images.length) % images.length);
		setZoomLevel(1);
		setPanPosition({x: 0, y: 0});
	}

	const handleZoomIn = () => {
		setIsTransitioning(true);
		setZoomLevel((prev) => Math.min(prev + 0.5, 3));
	}

	const handleZoomOut = () => {
		setIsTransitioning(true);
		setZoomLevel((prev) => {
			const newZoom = Math.max(prev - 0.5, 1);
			if (newZoom === 1) {
				setPanPosition({x: 0, y: 0});
			}
			return newZoom;
		});
	}

	const handleResetZoom = () => {
		setIsTransitioning(true);
		setZoomLevel(1);
		setPanPosition({x: 0, y: 0});
	}

	const handleMouseDown = (e) => {
		if (zoomLevel > 1) {
			setIsPanning(true);
			setIsTransitioning(false);
			setStartPan({
				x: e.clientX - panPosition.x,
				y: e.clientY - panPosition.y
			});
		}
	}

	const handleMouseMove = (e) => {
		if (isPanning && zoomLevel > 1) {
			setPanPosition({
				x: e.clientX - startPan.x,
				y: e.clientY - startPan.y
			});
		}
	}

	const handleMouseUp = () => {
		setIsPanning(false);
	}

	const handleTouchStart = (e) => {
		if (zoomLevel > 1 && e.touches.length === 1) {
			e.preventDefault();
			setIsPanning(true);
			setIsTransitioning(false);
			setStartPan({
				x: e.touches[0].clientX - panPosition.x,
				y: e.touches[0].clientY - panPosition.y
			});
		}
	}

	const handleTouchMove = (e) => {
		if (isPanning && zoomLevel > 1 && e.touches.length === 1) {
			e.preventDefault();
			setPanPosition({
				x: e.touches[0].clientX - startPan.x,
				y: e.touches[0].clientY - startPan.y
			});
		}
	}

	const handleTouchEnd = () => {
		setIsPanning(false);
		setPinchDistance(0);
	}

	// Double-click to zoom in/out
	const handleDoubleClick = (e) => {
		e.stopPropagation();
		setIsTransitioning(true);
		if (zoomLevel === 1) {
			// Zoom in to 2x at click position
			setZoomLevel(2);
			// Calculate position to zoom into clicked point
			const rect = e.currentTarget.getBoundingClientRect();
			const x = (e.clientX - rect.left - rect.width / 2) * -1;
			const y = (e.clientY - rect.top - rect.height / 2) * -1;
			setPanPosition({x, y});
		} else {
			// Zoom out to 1x
			setZoomLevel(1);
			setPanPosition({x: 0, y: 0});
		}
	}

	// Helper function to calculate distance between two touch points
	const getTouchDistance = (touch1, touch2) => {
		const dx = touch1.clientX - touch2.clientX;
		const dy = touch1.clientY - touch2.clientY;
		return Math.sqrt(dx * dx + dy * dy);
	}

	// Pinch-to-zoom for mobile (2 fingers)
	const handlePinchStart = (e) => {
		if (e.touches.length === 2) {
			e.preventDefault();
			setIsTransitioning(false);
			const distance = getTouchDistance(e.touches[0], e.touches[1]);
			setPinchDistance(distance);
			setLastZoomLevel(zoomLevel);
			setIsPanning(false);
		}
	}

	const handlePinchMove = (e) => {
		if (e.touches.length === 2 && pinchDistance > 0) {
			e.preventDefault();
			const distance = getTouchDistance(e.touches[0], e.touches[1]);
			const scale = distance / pinchDistance;
			const newZoom = Math.min(Math.max(lastZoomLevel * scale, 1), 3);
			setZoomLevel(newZoom);

			// Reset pan position when zooming out to 1x
			if (newZoom === 1) {
				setPanPosition({x: 0, y: 0});
			}
		} else if (e.touches.length === 1 && zoomLevel > 1) {
			// Single finger pan when zoomed
			if (isPanning) {
				setPanPosition({
					x: e.touches[0].clientX - startPan.x,
					y: e.touches[0].clientY - startPan.y
				});
			}
		}
	}

	// Keyboard accessibility
	const handleKeyDown = (e) => {
		if (!showZoomModal) return;

		switch (e.key) {
			case 'Escape':
				handleCloseZoomModal();
				break;
			case 'ArrowLeft':
				if (images.length > 1) {
					e.preventDefault();
					handlePrevImage();
				}
				break;
			case 'ArrowRight':
				if (images.length > 1) {
					e.preventDefault();
					handleNextImage();
				}
				break;
			case '+':
			case '=':
				e.preventDefault();
				handleZoomIn();
				break;
			case '-':
			case '_':
				e.preventDefault();
				handleZoomOut();
				break;
			case '0':
				e.preventDefault();
				handleResetZoom();
				break;
			default:
				break;
		}
	}

	// Add keyboard listener when modal opens
	useEffect(() => {
		if (showZoomModal) {
			window.addEventListener('keydown', handleKeyDown);
			// Prevent body scroll when modal is open
			document.body.style.overflow = 'hidden';
			return () => {
				window.removeEventListener('keydown', handleKeyDown);
				document.body.style.overflow = 'unset';
			};
		}
	}, [showZoomModal, images.length, zoomLevel]);

  const handleBrandClick = (brandRefId) => {
    window.location.href = '/brand/'+brandRefId;
  }

  const productKeywords = () => {
    var pname = (props.modalData.name).split("-").join(" ");
    return pname.split(" ").join(", ");
  };

	// Reset slider index if it's out of bounds when images change
	useEffect(() => {
		if (sliderIndex >= images.length) {
			console.log(`⚠️ Slider index ${sliderIndex} out of bounds, resetting to 0`);
			setSliderIndex(0);
		}
	}, [images, sliderIndex]);

  useEffect(() => {
    document.getElementsByClassName("product-cart")[0].style.visibility = "hidden";
    if(!(props.category.length > 0 && props.brands.length > 0)){
      props.productCategory({ get_type: 2, store_id: 1, lang });
      props.getProductBrands();
    }
  }, []);

  useEffect(() => {
    if (props.modalData && props.category !== undefined && !localStorage.getItem("isfilter")) {
      window.scrollTo(0, 0);
      localStorage.setItem("sub_cat_id", props.modalData.sub_cat_id);
      if(!props.oos){
        localStorage.setItem("mode","subcatoos");
        props.resetPage();
        props.getProductOutOfStock({
          sub_cat_id: props.modalData.sub_cat_id,
          store_id: 1,
          page: 1,
          oos: props.oos,
          brand_id: 0,
          lang
        });
      }
      else{
        localStorage.setItem("mode","subcat");
        props.resetPage();
        props.getProductsMappedwithSubCat({
          sub_cat_id: props.modalData.sub_cat_id,
          store_id: 1,
          page: 1,
          oos: props.oos,
          brand_id: 0,
          lang
        });
      }
      if(localStorage.getItem("user")){
        fetchOrderItems();
        fetchFavorites({ type: cartType === "express" ? 1 : 0 });
      }
    }
  }, [props.modalData]);

  useEffect(() => {
    if (pid !== undefined && props.modalData !== null && props.category.length > 0) {
      let body = {};
      body["item_ref_id"] = pid;
      body["lang"] = lang;
      props.ProductModalData(body);
    }
  }, [pid]);

  useEffect(() => {
    if(props.productfetch == false){
      history.push(`/not-found`);
    }
  },[props.productfetch]);

  useEffect(() => {
    if(props.loading){
      setIsLoadingAPI(true);
      return;
    }

    if(isLoadingAPI && !props.loading || props.products.length > 0){
      setIsSpinning(false);
    }
  }, [props.loading, props.products])
  
  useEffect(() => {
    if(Object.keys(props.modalData).length > 0) {
      props.getRelatedProducts({
        product_id: props.modalData.item_id,
        page: props.relatedProduct_page,
        limit: props.relatedProduct_limits
      })
    }

  }, [props.modalData])

  const checkPromo = () => {
    if(props.modalData && props.modalData.promo === 1 && props.modalData.promo_start_date !== null && props.modalData.promo_end_date !== null && compDate(props.modalData.promo_start_date, props.modalData.promo_end_date)){
      return true;
    }
    return false;
  }

  const [seenRelatedIds, setSeenRelatedIds] = useState([]);

  const handleSeenRelated = (id) => {
    setSeenRelatedIds(prev => {
      if (prev.includes(id)) return prev;
      return [...prev, id];
    });
  };

  const [seenProductInCatetoryIds, setSeenProductInCatetoryIds] = useState([]);
  const [openPromotionTooltipId, setOpenPromotionTooltipId] = useState(null);

  const handleSeenProductInCatetory = (id) => {
    setSeenProductInCatetoryIds(prev => {
      if (prev.includes(id)) return prev;
      return [...prev, id];
    });
  };

  useEffect(() => {
    if (deviceType && deviceType.mobile && (((seenRelatedIds.length > 0) && (seenRelatedIds.length % 4 == 0)) || ((seenProductInCatetoryIds.length > 0) && (seenProductInCatetoryIds.length % 4 == 0)))) {
	    logSeenEventView("product_detail", props.modalData, JSON.stringify([...seenRelatedIds]), JSON.stringify([...seenProductInCatetoryIds]));
    } else if (deviceType && deviceType.tablet && (((seenRelatedIds.length > 0) && (seenRelatedIds.length % 6 == 0)) || ((seenProductInCatetoryIds.length > 0) && (seenProductInCatetoryIds.length % 6 == 0)))) {
	    logSeenEventView("product_detail", props.modalData, JSON.stringify([...seenRelatedIds]), JSON.stringify([...seenProductInCatetoryIds]));
    } else if (deviceType && deviceType.desktop && (((seenRelatedIds.length > 0) && (seenRelatedIds.length % 12 == 0)) || ((seenProductInCatetoryIds.length > 0) && (seenProductInCatetoryIds.length % 12 == 0)))) {
	    logSeenEventView("product_detail", props.modalData, JSON.stringify([...seenRelatedIds]), JSON.stringify([...seenProductInCatetoryIds]));
    }
  }, [seenRelatedIds, seenProductInCatetoryIds])

  useEffect(() => {
    const handleDocumentClick = () => {
      setOpenPromotionTooltipId(null);
    };

    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleTogglePromotionTooltip = (e, promoId) => {
    e.stopPropagation();
    setOpenPromotionTooltipId(prev => (prev === promoId ? null : promoId));
  };

  return (
    <>
     { props.modalData ? (
    <>
      <Helmet defer={false}>
        {/* Basic Meta Tags */}
        <title>{props.modalData.name || 'Delishop'}</title>
        <link rel="canonical" href={`https://delishop.asia${window.location.pathname}`}/>

        {/* Primary Meta Tags */}
        <meta name="title" content={props.modalData.name || 'Delishop'}/>
        <meta name="description" content={props.modalData.about_item || props.modalData.name}/>
        <meta name="keywords" content={props.modalData.name ? productKeywords() : ""}/>
        <meta itemProp="image" content={props.modalData.default_image_url || ''}/>

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="product"/>
        <meta property="og:title" content={props.modalData.name || 'Delishop'}/>
        <meta property="og:description" content={props.modalData.about_item || props.modalData.name}/>
        <meta property="og:image" content={props.modalData.default_image_url || ''}/>
        <meta property="og:url" content={`https://delishop.asia${window.location.pathname}`}/>
	      <meta property="og:site_name" content="Delishop"/>

	      {/* Twitter Card */}
	      <meta name="twitter:card" content="summary_large_image"/>
	      <meta name="twitter:title" content={props.modalData.name || 'Delishop'}/>
	      <meta name="twitter:description" content={props.modalData.about_item || props.modalData.name}/>
	      <meta name="twitter:image" content={props.modalData.default_image_url || ''}/>

	      {/* Robots */}
	      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"/>

        {/* Product Schema Markup */}
        {props.modalData.promo === 1 ? (
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": props.modalData.name,
                "description": props.modalData.about_item ?? '',
                "image": props.modalData.default_image_url ?? '',
                "sku": props.modalData.product_code,
                "brand": {
                  "@type": "Brand",
                  "name": props.modalData.list_brands?.[0]?.brand_name || ""
                },
                "offers": {
                  "@type": "Offer",
                  "url": `https://delishop.asia${window.location.pathname}`,
                  "priceCurrency": "USD",
                  "price": props.modalData.promo_price,
                  "description": props.modalData.about_item ?? '',
                  "image": props.modalData.default_image_url ?? '',
                  "availability": props.modalData.store_items_price_types?.[0]?.is_available === true
                      ? props.modalData.store_items_price_types?.[0]?.available_quantity > 0 ? "https://schema.org/InStock" : "https://schema.org/BackOrder"
                      : "https://schema.org/Discontinued",
                  "priceValidUntil": props.modalData.promo_end_date || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "priceType": "https://schema.org/ListPrice",
                    "price": props.modalData.store_items_price_types?.[0]?.price,
                    "priceCurrency": "USD",
                  },
                },
              })}
            </script>
        ) : (
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": props.modalData.name,
                "description": props.modalData.about_item ?? '',
                "image": props.modalData.default_image_url ?? '',
                "sku": props.modalData.product_code,
                "brand": {
                  "@type": "Brand",
                  "name": props.modalData.list_brands?.[0]?.brand_name || ""
                },
                "offers": {
                  "@type": "Offer",
                  "url": `https://delishop.asia${window.location.pathname}`,
                  "priceCurrency": "USD",
                  "price": props.modalData.store_items_price_types?.[0]?.price,
                  "description": props.modalData.about_item ?? '',
                  "image": props.modalData.default_image_url ?? '',
                  "availability": props.modalData.store_items_price_types?.[0]?.is_available === true
                      ? props.modalData.store_items_price_types?.[0]?.available_quantity > 0 ? "https://schema.org/InStock" : "https://schema.org/BackOrder"
                      : "https://schema.org/Discontinued",
                  "priceValidUntil": props.modalData.promo_end_date || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
                }
              })}
            </script>
        )}

	      {/* Breadcrumb Schema Markup */}
	      <script type="application/ld+json">
		      {JSON.stringify({
			      "@context": "https://schema.org",
			      "@type": "BreadcrumbList",
			      "itemListElement": [
				      {
					      "@type": "ListItem",
					      "position": 1,
					      "name": "Home",
					      "item": "https://delishop.asia/"
				      },
				      {
					      "@type": "ListItem",
					      "position": 2,
					      "name": props.modalData.name,
					      "item": `https://delishop.asia${window.location.pathname}`
				      }
			      ]
		      })}
	      </script>

      </Helmet>
    </>) : null
     }
      {/* {props.isloading && <PageLoader />} */}
      {window.location.pathname.split("/").length > 1 &&
      window.location.pathname.split("/").length <= 3 &&
      window.location.pathname.split("/")[2] !== "" && props.modalData && props.modalData.name ? (
        <QuickViewWrapper className="product-page" itemScope itemType="http://schema.org/Product" style={{ paddingTop: mql.matches ? "70px" : "10vh" }}>

          <div className="bread-crumb-wrapper">
             <Breadcrumb style={{ width: "100%"}}>
                {/* <svg xmlns="http://www.w3.org/2000/svg" onClick={openFilterModal} style={{ marginRight: "5px", cursor: "pointer" }} height="40" viewBox="0 -960 960 960" width="40"><path d="M120-240v-60h240v60H120Zm0-210v-60h480v60H120Zm0-210v-60h720v60H120Z" /></svg> */}
                <MButton
                  variant="contained"
                  style={{
                    minWidth: 54,
                    marginInlineEnd: 10,
                    padding: 6,
                    backgroundColor: "#e9ecef",
                  }}
                  onClick={openFilterModal}
                >
                  <Tune style={{ fontSize: 26 }} />
                </MButton>
              <Breadcrumb.Item href="/" style={{display:"flex",alignItems:"center"}}>{ t('shop_address_home_label') }</Breadcrumb.Item>
                <Breadcrumb.Item href={"/" + pid} className="bread_crumb_style" active style={{ display: "flex", alignItems: "center" }}>
                {props.modalData.name}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

        <ProductDetailsWrapper className="product-card" dir="ltr">
          <ProductPreview>
            <ProductImageContainer>
	            {images.length > 1 &&
		            <ProductImageSlider>
                { images.map((image,index) =>
	                <ProductImageSliderItem key={index}
	                                        className={index === sliderIndex ? "product-image-wrapper active" : "product-image-wrapper"}>
                    <img src={image} className="product-image" alt="product_image" onClick={()=>handleClickSliderImage(index)} onError={(e) => {e.target.onerror = null; e.target.src = require('../assets/images/delishop-favicons.png')}}/>
                  </ProductImageSliderItem>
              )
                }
              </ProductImageSlider>
              }
	            <ProductMainImage className="product-image-wrapper" onClick={() => handleImageClick(sliderIndex)}
	                              style={{cursor: 'pointer'}} title="Click to view full image">
              <LazyLoad height={180} placeholder={<img alt="product_image" src={require('../image/Background.png')} style={{position: "relative", height: "180px", width: "auto"}} />}>
                  {images[0] === undefined || images[0] === null || images.length === 0 ?
                  <img src={require('../assets/images/delishop-favicons.png')} className="product-image mainImage" alt="product_image" onError={(e) => {e.target.onerror = null; e.target.src = require('../assets/images/delishop-favicons.png')}}/>
                  :
                  <img src={images[sliderIndex]} className="product-image mainImage" alt="product_image" onError={(e) => {e.target.onerror = null; e.target.src = require('../assets/images/delishop-favicons.png')}}/>
                  }
              </LazyLoad>
		            <ZoomIconOverlay onClick={(e) => {
			            e.stopPropagation();
			            handleImageClick(sliderIndex);
		            }} title="Click to view full image">
		              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			              <circle cx="11" cy="11" r="8"></circle>
			              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
		              </svg>
	              </ZoomIconOverlay>
              </ProductMainImage>
            </ProductImageContainer>
          </ProductPreview>
          <ProductInfoWrapper dir={"ltr"}>
            <ProductInfo>
              {/* {props.modalData &&
                props.modalData.list_brands &&
                props.modalData.list_brands.length > 0 && (
                  <div itemProp={"brand"}>{props.modalData.list_brands[0].name}</div>
                )} */}
              <meta itemProp="sku" content={props.modalData.product_code} />
              <ProductTitlePriceWrapper>
                <ProductTitle itemProp={"name"}>
                  {props.modalData.name !== " "
                    ? props.modalData.name
                    : props.modalData.weight +
                      " " +
                      props.modalData.weight_unit}
                </ProductTitle>
              </ProductTitlePriceWrapper>
              {props.modalData &&
                props.modalData.list_brands &&
                props.modalData.list_brands.length > 0 && (
                <>
                  {/* <span style={{
                    padding: "4px 8px",
                  }}>
                    <Minus color="#9cc54b" height="4px" width="20px"/>
                  </span>  */}
                  <ProductBrand itemProp={"brand"} 
                    onClick={() => handleBrandClick(props.modalData.list_brands[0].brand_ref_id)}>
                    {props.modalData.list_brands[0].name} 
                  </ProductBrand>
                </>
              )}

              {/* Price row: left = regular/promo price, right = DeliPoints deal */}
              <PriceRow>
                {/* Left: price stack + save badge */}
                <PriceLeftCol>
                  <ProductPriceWrapper itemProp={"offers"} itemScope itemType={"https://schema.org/Offer"}>
                    {/* Original price — small + strikethrough when promo active, large green when no promo */}
                    {props.modalData &&
                      props.modalData.store_items_price_types &&
                      props.modalData.store_items_price_types[0].price && (
                        <ProductPrice className={ checkPromo() ? "strike-through" : "" }>
                          <span itemProp={checkPromo() ? "oldPriceCurrency" : "priceCurrency"} content={"USD"}>{"$"}</span>
                          <span itemProp={checkPromo() ? "oldPrice" : "price"} content={props.modalData.store_items_price_types[0].price}>
                            {parseFloat(props.modalData.store_items_price_types[0].price).toFixed(2)}
                          </span>
                        </ProductPrice>
                      )}
                    {/* Promo price — large orange, shown below original when promo active */}
                    {checkPromo() && (
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <PromoPrice itemscope itemtype="https://schema.org/PriceSpecification">
                          <meta itemProp={"@type"} content={"UnitPriceSpecification"} />
                          <meta itemProp={"priceType"} content={"https://schema.org/ListPrice"} />
                          <span itemProp={"priceCurrency"} content={"USD"}>{"$"}</span>
                          <span itemProp={"price"} content={props.modalData.promo_price}>
                            {parseFloat(props.modalData.promo_price).toFixed(2)}
                          </span>
                          <meta itemProp="priceValidUntil" content={props.modalData.promo_end_date} />
                        </PromoPrice>
                        {/* Save badge inline with promo price */}
                        <SaveBadge>
                          Save ${(parseFloat(props.modalData.store_items_price_types[0].price) - parseFloat(props.modalData.promo_price)).toFixed(2)}
                        </SaveBadge>
                      </div>
                    )}
                    <meta itemProp="url" content={"https://delishop.asia" + window.location.pathname} />
                  </ProductPriceWrapper>
                </PriceLeftCol>

                {/* Right: DeliPoints deal price */}
                {/* {props.modalData.dp_price && dpBalance && dpBalance >= props.modalData.dp_price && (
                  <DeliPointsDealBox>
                    <span className="dp-deal-label">DeliPoints Deal</span>
                    <ProductPrice>
                      <span className="dp-deal-price">${parseFloat(props.modalData.dp_price).toFixed(2)}</span>
                    </ProductPrice>
                  </DeliPointsDealBox>
                )} */}
              </PriceRow>

              {(props.modalData.same_day === 1 && props.modalData.is_shop_normal_open) || props.modalData.available_tommorrow === 1 || checkPromo()
                ? <div className="w-100" style={{ color: "#000", fontSize: "1.5rem", marginBottom: 15, display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {props.modalData.same_day === 1 && props.modalData.is_shop_normal_open && (
                    <span className="bg-success pb-1 px-1 rounded text-white">{ t('shop_item_get_same_day') }</span>
                  )}
                  {!(props.modalData.same_day === 1 && props.modalData.is_shop_normal_open) && props.modalData.available_tommorrow === 1 && (
                    <span className="bg-warning pb-1 px-1 rounded text-white">{ t('shop_item_get_tomorrow') }</span>
                  )}
                  {checkPromo() && (
                    <span className="bg-danger pb-1 px-1 rounded text-white">{ t('shop_item_promo_label') }</span>
                  )}
                </div>
                : null
              }

              {props.modalData && props.modalData.store_items_price_types
                ? <div style={{ display: "flex", alignItems: "center", gap: "1rem"}}>
                    <ProductWeight itemProp={"weight"}>{props.modalData.store_items_price_types[0].name}</ProductWeight>
                    {
                      props.modalData.countries[0] &&
                      <div><FlagIcon code={props.modalData.countries[0].code.toLowerCase()} size="lg" /></div>
                    }
                  </div>
                : null
              }

              <div className={`availability ${props.cartType}`}>
                <p>{ t('shop_item_stock_availability_label') }:&nbsp;
                  { !props.modalData.store_items_price_types[0].available_quantity
                    ? <span className="stock-label out-of-stock">{ t('shop_item_out_of_stock') }</span>
                    : <span className="stock-label">{ t('shop_item_in_stock_label') }</span>
                  }
                </p>
                <p className="product-code">{ t('shop_item_sku') }: {props.modalData.product_code}</p>
              </div>
              {props.modalData && props.modalData.store_items_price_types
                ? <ProductCartWrapper>
                  <ProductCartBtn>
                    { !props.modalData.store_items_price_types[0].available_quantity
                      ? null :
                        <>
                          {/* Add to basket: stepper when in cart, plain button when not */}
                          <CartActionRow>
                            {(isInCart(props.modalData.item_id) && !justRemovedFromCart && itemNormalQty > 0) ? (
                              <AddToCartStepper onClick={(e) => e.stopPropagation()}>
                                <button
                                  className="btn-cart-left"
                                  disabled={isLoading}
                                  onClick={handleRemoveClick}
                                >
                                  {itemNormalQty === 1 && (redeemQuantity ?? 0) === 0 ? <DeleteOutlined style={{ fontSize: 18 }} /> : <Minus />}
                                </button>
                                <span className="cart-qty">{itemNormalQty}</span>
                                <button
                                  className="btn-cart-right"
                                  disabled={isLoading}
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    stepperLoadingRef.current = true;
                                    setIsLoading(true);
                                    const itemResp = await itemToCartService.addItem(props.modalData.item_id, cartType, itemNormalQty + 1, 0, 0, redeemQuantity ?? 0, false);
                                    if (itemResp.success) {
                                      setJustRemovedFromCart(false);
                                      logAddToCart(itemResp.data);
                                      fetchOrderItems(cartType);
                                    }
                                    stepperLoadingRef.current = false;
                                    setIsLoading(false);
                                  }}
                                >
                                  <Plus />
                                </button>
                              </AddToCartStepper>
                            ) : (
                              <Button
                                variant="success"
                                className={`btn btn-success pr${props.modalData.item_id}`}
                                disabled={isLoading}
                                onClick={(e) => handleAddClick(e)}
                                style={{ minWidth: "200px" }}
                              >
                                {isLoading
                                  ? <Spinner animation="border" role="status" size="sm">
                                      <span className="sr-only">{t('toast_downloading')}</span>
                                    </Spinner>
                                  : <span className="product-buy">{t('button_add_to_basket')}</span>
                                }
                              </Button>
                            )}

                            {/* Redeem DeliPoints button / stepper */}
                            {props.modalData.dp_price && (
                              (redeemQuantity > 0 && !justRemovedRedeemItem) ? (
                                <RedeemStepperWrapper onClick={(e) => e.stopPropagation()}>
                                  {/* Left: trash when qty=1, minus otherwise */}
                                  <button
                                    className="btn-redeem-left"
                                    disabled={isLoading}
                                    onClick={handleRedeemDecrease}
                                  >
                                    {redeemQuantity === 1 ? <DeleteOutlined style={{ fontSize: 18 }} /> : <Minus />}
                                  </button>

                                  {/* Center: quantity + price label */}
                                  <span className="redeem-label">
                                    {redeemQuantity}&nbsp;(${parseFloat(props.modalData.dp_price).toFixed(2)}&nbsp;+{props.modalData.dp_points}&nbsp;pts)
                                  </span>

                                  {/* Right: info icon (max qty reached or insufficient balance) or plus */}
                                  {dpBalance < props.modalData.dp_points * (redeemQuantity + 1) ? (
                                    <div className="redeem-info-wrapper">
                                      <button
                                        className="btn-redeem-info"
                                        onClick={(e) => { e.stopPropagation(); setShowRedeemTooltip(v => !v); }}
                                      >
                                        <ErrorOutline style={{ fontSize: 18 }} />
                                      </button>
                                      {showRedeemTooltip && (
                                        <div className="redeem-tooltip">
                                          <>You have used {props.modalData.dp_points * redeemQuantity} points<br />There are not sufficient DeliPoints to add more items to your basket</>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <button
                                      className="btn-redeem-right"
                                      disabled={isLoading}
                                      onClick={handleRedeemIncrease}
                                    >
                                      <Plus />
                                    </button>
                                  )}
                                </RedeemStepperWrapper>
                              ) : (
                                dpBalance && dpBalance >= props.modalData.dp_points ? (
                                  <Button
                                    className={`btn-redeem pr${props.modalData.item_id}`}
                                    disabled={isLoading}
                                    onClick={(e) => handleRedeemClick(e)}
                                    title="Add with DeliPoints"
                                  >
                                    {isLoading
                                      ? <Spinner animation="border" role="status" size="sm">
                                          <span className="sr-only">{t('toast_downloading')}</span>
                                        </Spinner>
                                      : <>
                                          <span style={{ fontSize: "1.5rem", fontWeight: 700, color: "#fff", whiteSpace: "nowrap" }}>
                                            ${parseFloat(props.modalData.dp_price).toFixed(2)}
                                          </span>
                                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                            <span style={{ fontSize: "15px", lineHeight: 1.2, fontWeight: 500, whiteSpace: "nowrap", color: "rgba(255,255,255,0.7)" }}>
                                              Redeem {props.modalData.dp_points}
                                            </span>
                                            <span style={{ fontSize: "15px", lineHeight: 1.2, fontWeight: 600, color: "#fff" }}>
                                              DeliPoints
                                            </span>
                                          </div>
                                        </>
                                    }
                                  </Button>
                                ) : null
                              )
                            )}

                            {/* Favorite button */}
                            <FavoriteContainer className="product-info" style={{ width: "44px", height: "44px" }}>
                              <Button
                                variant="light"
                                size="sm"
                                className="btn-favorite"
                                onClick={(e) => handleAddRemoveFavorite(e)}
                              >
                                {isInFavorites(props.modalData.item_id)
                                  ? <Favorite className="favorite-icon" style={{ fontSize: "44px", height: "44px", width: "44px" }} />
                                  : <FavoriteBorder className="favorite-icon" style={{ fontSize: "44px", height: "44px", width: "44px" }} />
                                }
                              </Button>
                            </FavoriteContainer>
                          </CartActionRow>
                        </>
                    }
                  </ProductCartBtn>
                  {/*Display product earn promotion*/}
                  {props.modalData.dp_earn_promotions && props.modalData.dp_earn_promotions.length > 0 && (
                    props.modalData.dp_earn_promotions
                      .filter(promo => promo.is_active && compDate(promo.start_date, promo.end_date))
                      .map((promo) => (
                        <EarnPromotionBadge key={promo._id}>
                          <CardGiftcard style={{ fontSize: "32px" }} />
                          <span className="promotion-text">{promo.display_text}</span>
                          <EarnPromotionTooltipWrapper onClick={(e) => e.stopPropagation()}>
                            <ErrorOutline
                              className="info-icon"
                              onClick={(e) => handleTogglePromotionTooltip(e, promo._id)}
                            />
                            <span
                              className={`tooltip-text ${openPromotionTooltipId === promo._id ? "is-visible" : ""}`}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {promo.points_multiplier
                                ? `Earn ${Math.round((promo.points_multiplier - 1) * 100)}% bonus DeliPoints on this product`
                                : promo.fixed_points_multiple_use
                                  ? `Earn ${promo.fixed_points} bonus DeliPoints per item`
                                  : `Earn ${promo.fixed_points} bonus DeliPoints on this product (awarded once per order)`
                              } */}
                              {lang === "kh" && promo.description_kh && promo.description_kh !== "" 
                                ? promo.description_kh
                                : promo.description
                              }
                              <br />
                              <a href="/delipoints" target="_blank" rel="noopener noreferrer" className="learn-more-link">
                                { t('home_earn_promotion_learn_more') }
                              </a>
                            </span>
                          </EarnPromotionTooltipWrapper>
                        </EarnPromotionBadge>
                      ))
                  )}
                </ProductCartWrapper>
                : null
              }


              <div className="product-info-wrapper">
                <div className="product-content">
                  <div className="product-detail">
                    {props.modalData.about_item && (
                      <>
                        <div className="productInfoTitle">
                          <strong>{ t('home_item_popup_about_label') }</strong>
                        </div>
                        <ProductDescription className="ql-snow ql-picker" itemProp={"description"}>
                          <ReadMore className="ql-snow ql-picker" character={1200}>
                            {props.modalData.about_item}
                          </ReadMore>
                        </ProductDescription>
                      </>
                    )}
	                  {props.modalData?.dietaryPreferences && (
		                  <DietaryPreferences dietaryPreferences={props.modalData?.dietaryPreferences}
		                                      style={{marginBottom: "5px", marginLeft: "10px"}}/>
	                  )}
                    {props.modalData.more_item_info && (
                      <>
                        <div className="productInfoTitle">{ t('home_item_popup_item_info') }</div>
                        <ProductDescription className="ql-snow ql-picker">
                          <ReadMore className="ql-snow ql-picker" character={600}>
                            {props.modalData.more_item_info}
                          </ReadMore>
                        </ProductDescription>
                      </>
                    )}
                    {props.modalData.how_to_use && (
                      <>
                        <div className="productInfoTitle">
                          <strong>{ t('home_item_popup_how_to_use') }</strong>
                        </div>
	                      <ProductDescription className="ql-snow ql-picker">
                          <ReadMore character={600}>
                            {props.modalData.how_to_use}
                          </ReadMore>
                        </ProductDescription>
                      </>
                    )}
                    {props.modalData.ingredients && (
                      <>
                        <div className="productInfoTitle">
                          <strong>{ t('home_item_popup_ingredient_label') }</strong>
                        </div>
	                      <ProductDescription className="ql-snow ql-picker">
                          <ReadMore character={600}>
                            {props.modalData.ingredients}
                          </ReadMore>
                        </ProductDescription>
                      </>
                    )}
                    {props.modalData &&
                      props.modalData.list_brands &&
                      props.modalData.list_brands.length > 0 &&
                      props.modalData.list_brands[0].description && (
                      <>
                        <div className="productInfoTitle">
                          <strong>{ t('home_item_popup_about_the_brand_label') }</strong>
                        </div>
                        <ProductDescription className="ql-snow ql-picker" itemProp={"brand-description"}>
                          <ReadMore className="ql-snow ql-picker" character={1200}>
                            {props.modalData.list_brands[0].description}
                          </ReadMore>
                        </ProductDescription>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </ProductInfo>
          </ProductInfoWrapper>
        </ProductDetailsWrapper>
        </QuickViewWrapper>

      ) : null}
      {/* related Product  */}
      {Object.keys(props.relatedProducts).length > 0 &&
        <RelatedProduct
          deviceType={deviceType}
          props={props}
          isCloseSEO={true}
          onSeenProduct={handleSeenRelated}
        />
      }
      {props.modalData && props.modalData.name && deviceType.desktop ? (
        <>
          <MainContentArea style={{ paddingTop: mql.matches
              ? <>
                { window.location.pathname.split("/").length > 1 &&
                  window.location.pathname.split("/").length <= 2 &&
                  window.location.pathname.split("/")[1] !== "" && props.modalData && props.modalData.name
                    ? '1vh'
                    : '9vh'
                }
              </>
              : "1vh" }}>
            <ContentSection id="productBlock" style={{width: "100%"}}>
              <div ref={targetRef} style={{
                overflow: 'hidden',
                borderTop: '1px solid #e1e1e1',
                paddingTop: 10,
              }}>
                {
                  !isSpinning ? (
                    <Products
                      type={PAGE_TYPE}
                      deviceType={deviceType}
                      fetchLimit={50}
                      props={props}
                      isFilterModal={showFilter}
                      toggleFilter={openFilterModal}
                      isCloseSEO={true}
                      onSeenProduct={handleSeenProductInCatetory}
                    />
                  ):(null)
                }

                {/* <BrandsHome deviceType={deviceType} props={props} /> */}
                <PartnerHome deviceType={deviceType} props={props} />
              </div>
            </ContentSection>
          </MainContentArea>
        </>
      ) : (
        <MainContentArea style={{ paddingTop: "9vh" }}>
          <ContentSection style={{ width: "100%" }}>
            {
              !isSpinning ? (
                <Products
                  type={PAGE_TYPE}
                  deviceType={deviceType}
                  fetchLimit={50}
                  props={props}
                  isFilterModal={showFilter}
                  toggleFilter={openFilterModal}
                  isCloseSEO={true}
                  onSeenProduct={handleSeenProductInCatetory}
                />                
              ):(null)
            }

          </ContentSection>
        </MainContentArea>
      )}
      <CartPopUp deviceType={deviceType} />
      {isSpinning ?
	      <ProductDetailSkeleton isMobile={mqs.matches}/>
        : null }
      <SimpleMessageDialog
        show={showError}
        message={errorMessage}
        showHeader={showHeaderDialog}
        closeLabel={closeLabel}
        confirmLabel={confirmLabel}
        headerLabel={dialogHeaderLabel}
        isConfirmButton={isConfirmButton}
        onClose={closeSimpleDialog}
        onConfirm={onConfirm}
        backdrop={simpleDialogBackdrop}
        loading={dialogLoading}
        cartType={cartType}
      />

	    {showZoomModal && (
		    <ImageZoomModal
			    onClick={handleCloseZoomModal}
			    role="dialog"
			    aria-modal="true"
			    aria-label="Image zoom viewer"
		    >
			    <ZoomModalContent
				    role="document"
				    aria-label="Zoom controls and image display"
			    >
				    {/* Navigation Arrows */}
				    {images.length > 1 && (
					    <>
						    <ZoomNavButton
							    className="prev"
							    onClick={(e) => {
								    e.stopPropagation();
								    handlePrevImage();
							    }}
							    aria-label="Previous image"
							    title="Previous image (Left arrow key)"
						    >
							    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
							         aria-hidden="true">
								    <polyline points="15 18 9 12 15 6"></polyline>
							    </svg>
						    </ZoomNavButton>
						    <ZoomNavButton
							    className="next"
							    onClick={(e) => {
								    e.stopPropagation();
								    handleNextImage();
							    }}
							    aria-label="Next image"
							    title="Next image (Right arrow key)"
						    >
							    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
							         aria-hidden="true">
								    <polyline points="9 18 15 12 9 6"></polyline>
							    </svg>
						    </ZoomNavButton>
					    </>
				    )}

				    {/* Zoomed Image Container */}
				    <ZoomedImageContainer
					    onClick={(e) => e.stopPropagation()}
					    onDoubleClick={handleDoubleClick}
					    onMouseDown={handleMouseDown}
					    onMouseMove={handleMouseMove}
					    onMouseUp={handleMouseUp}
					    onMouseLeave={handleMouseUp}
					    onTouchStart={(e) => {
						    if (e.touches.length === 2) {
							    handlePinchStart(e);
						    } else if (e.touches.length === 1) {
							    handleTouchStart(e);
						    }
					    }}
					    onTouchMove={(e) => {
						    if (e.touches.length === 2) {
							    handlePinchMove(e);
						    } else {
							    handleTouchMove(e);
						    }
					    }}
					    onTouchEnd={handleTouchEnd}
					    style={{
						    cursor: zoomLevel > 1 ? (isPanning ? 'grabbing' : 'grab') : 'default',
						    touchAction: 'none',
						    WebkitTouchCallout: 'none',
						    WebkitUserSelect: 'none'
					    }}
					    role="img"
					    aria-label={`Product image ${zoomImageIndex + 1} of ${images.length}, zoom level ${Math.round(zoomLevel * 100)}%`}
					    tabIndex={0}
				    >
					    <ZoomedImage
						    src={images[zoomImageIndex]}
						    alt="zoomed product"
						    className={isTransitioning ? 'transitioning' : ''}
						    onError={(e) => {
							    e.target.onerror = null;
							    e.target.src = require('../assets/images/delishop-favicons.png')
						    }}
						    style={{
							    transform: `scale(${zoomLevel}) translate(${panPosition.x / zoomLevel}px, ${panPosition.y / zoomLevel}px)`,
							    cursor: zoomLevel > 1 ? (isPanning ? 'grabbing' : 'grab') : 'default'
						    }}
						    draggable="false"
					    />
				    </ZoomedImageContainer>

				    {/* Close Button */}
				    <CloseZoomButton
					    onClick={(e) => {
						    e.stopPropagation();
						    handleCloseZoomModal();
					    }}
					    aria-label="Close zoom viewer"
					    title="Close (ESC key)"
				    >
					    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
					         aria-hidden="true">
						    <line x1="18" y1="6" x2="6" y2="18"></line>
						    <line x1="6" y1="6" x2="18" y2="18"></line>
					    </svg>
				    </CloseZoomButton>

				    {/* Zoom Controls */}
				    <ZoomControlsContainer onClick={(e) => e.stopPropagation()} role="toolbar" aria-label="Zoom controls">
					    <ZoomControlButton
						    onClick={(e) => {
							    e.stopPropagation();
							    handleZoomOut();
						    }}
						    disabled={zoomLevel <= 1}
						    title="Zoom Out (- key)"
						    aria-label="Zoom out"
					    >
						    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
						         aria-hidden="true">
							    <circle cx="11" cy="11" r="8"></circle>
							    <line x1="8" y1="11" x2="14" y2="11"></line>
							    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						    </svg>
					    </ZoomControlButton>

					    <ZoomLevelIndicator aria-live="polite" aria-atomic="true">
						    {Math.round(zoomLevel * 100)}%
					    </ZoomLevelIndicator>

					    <ZoomControlButton
						    onClick={(e) => {
							    e.stopPropagation();
							    handleZoomIn();
						    }}
						    disabled={zoomLevel >= 3}
						    title="Zoom In (+ key)"
						    aria-label="Zoom in"
					    >
						    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
						         aria-hidden="true">
							    <circle cx="11" cy="11" r="8"></circle>
							    <line x1="11" y1="8" x2="11" y2="14"></line>
							    <line x1="8" y1="11" x2="14" y2="11"></line>
							    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						    </svg>
					    </ZoomControlButton>

					    {zoomLevel > 1 && (
						    <ZoomControlButton
							    onClick={(e) => {
								    e.stopPropagation();
								    handleResetZoom();
							    }}
							    title="Reset Zoom (0 key)"
							    style={{marginLeft: '8px'}}
							    aria-label="Reset zoom to 100%"
						    >
							    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
							         aria-hidden="true">
								    <path d="M1 4v6h6"></path>
								    <path d="M23 20v-6h-6"></path>
								    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
							    </svg>
						    </ZoomControlButton>
					    )}
				    </ZoomControlsContainer>

				    {/* Image Counter */}
				    {images.length > 1 && (
					    <ZoomImageCounter aria-live="polite" aria-atomic="true">
						    Image {zoomImageIndex + 1} of {images.length}
					    </ZoomImageCounter>
				    )}

				    {/* Thumbnail Preview Strip */}
				    {images.length > 1 && (
					    <ZoomThumbnailStrip onClick={(e) => e.stopPropagation()} role="list" aria-label="Image thumbnails">
						    {images.map((img, idx) => (
							    <ZoomThumbnail
								    key={idx}
								    src={img}
								    alt={`Go to image ${idx + 1}`}
								    className={idx === zoomImageIndex ? 'active' : ''}
								    onClick={(e) => {
									    e.stopPropagation();
									    setZoomImageIndex(idx);
									    setZoomLevel(1);
									    setPanPosition({x: 0, y: 0});
								    }}
								    onError={(e) => {
									    e.target.onerror = null;
									    e.target.src = require('../assets/images/delishop-favicons.png')
								    }}
								    role="button"
								    tabIndex={0}
								    aria-label={`View image ${idx + 1}`}
								    aria-current={idx === zoomImageIndex ? 'true' : 'false'}
								    title={`View image ${idx + 1}`}
							    />
						    ))}
					    </ZoomThumbnailStrip>
				    )}
			    </ZoomModalContent>
		    </ImageZoomModal>
	    )}

    </>
  );
};

const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    modalData: state.productReducer.modalData,
    products: state.productReducer.products,
    allproducts: state.productReducer.allproducts,
    isHasMore: state.productReducer.isHasMore,
    category: state.productReducer.category,
    sliders: state.globalReducer.sliders,
    loading: state.globalReducer.loading,
    brands: state.productReducer.brands,
    filterBrands: state.productReducer.filterBrands,
    FilteredNameProducts: state.productReducer.FilteredNameProducts,
    filteredProducts: state.productReducer.filteredProducts,
    suggested_subcats: state.productReducer.suggested_subcats,
    all_suggested_subcats: state.productReducer.all_suggested_subcats,
    productfetch: state.productReducer.productfetch,
    isloading: state.globalReducer.isloading,
    oos: state.globalReducer.oos,
    cat_refs: state.productReducer.cat_refs,
    cartType: state.cartReducer.cartType,
    relatedProducts: state.productReducer.relatedProducts,
    relatedProduct_page: state.productReducer.relatedProduct_page,
    relatedProduct_limits: state.productReducer.relatedProduct_limits,
    total_relatedProduct_page : state.productReducer.total_relatedProduct_page,
    all_pages: state.globalReducer.all_pages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    productCategory: (data) => productCategory(data, dispatch),
    ProductModalData: (data) => ProductModalData(data, dispatch),
    ResetModalData: (data) => ProductModalData(data, dispatch),
    searchSuggestions: (data) => searchSuggestions(data, dispatch),
    searchStoreProduct: (data) => searchStoreProduct(data, dispatch),
    getProductsMappedwithSubCat: (data) => getProductsMappedwithSubCat(data, dispatch),
    getProductsMappedwithCat: (data) => getProductsMappedwithCat(data, dispatch),
    // offerSlider: (data) => offerSlider(data, dispatch),
    getProductOutOfStock: (body) => getProductOutOfStock(body, dispatch),
    getProductOutOfStockCat: (body) => getProductOutOfStockCat(body, dispatch),
    getProductBrands: () => getProductBrands(dispatch),
    getSortProductsName: (type, products) =>
      getSortProductsName(type, products, dispatch),
    getSortProductsPrice: (type, products) =>
      getSortProductsPrice(type, products, dispatch),
    getProductFilterBrands: (body, products, allproducts, sub_cat_id, cat_id, brandName, oos, text) =>
      getProductFilterBrands(body, products, allproducts, sub_cat_id, cat_id, brandName, oos, text, dispatch),
    sortByNameProduct: (type, products) =>
      sortByNameProduct(type, products, dispatch),
    oosModified: (data) => oosModified(data, dispatch),
    changePage: (data) => changePage(data, dispatch),
    resetPage: () => resetPage(dispatch),
    getRelatedProducts: (body) => getRelatedProducts(body, dispatch),
    changeRelatedProductPage: (body) => changeRelatedProductPage(body, dispatch),
    resetRelatedProductPage: () => resetRelatedProductPage(dispatch),
    getPartnerPages: (body) => getPartnerPages(body,dispatch),
    fetchCart: (body) => fetchCart(body, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductData);

const imageWrapper = {
  width: "400px",
  height: "400px",
  display: "flex",
  alignItems: "center"
}


const QuickViewWrapper = styled.div`
  margin: 0 auto;
  background-color: #FFFFFF;
  
  .bread-crumb-wrapper {
    display: flex;
    width: 100%;
    padding: 0 30px;
    margin-top: 50px;
    a{
      color: #4b4a49;
    }
  }
  .bread_crumb_style{
      color: #9cc54b;
  }
  .ql-snow > ul ol li {
    list-style: auto !important;
  }
`;

const ProductDetailsWrapper = styled.div`
  background-color: #fff;
  position: relative;
  display: flex;
  flex-wrap: wrap;
    align-items: flex-start;
  min-height: 140px;
  overflow: hidden;
  box-sizing: border-box;
  
  .product-info-wrapper {
    width: 100%;
    padding: 0;
    margin: 0 auto;
    .product-navigation {
      display: flex;
      color: #424561;
      gap: 80px;
      font-size: 18px;
      justify-content: center;
      margin-bottom: 20px;
    }
    .product-content {
      padding-bottom: 30px;
    }
    .product-review {
      display: none;
      &.show { display: block }
    }
  }
  
  * {
    box-sizing: border-box;
  }
  @media (max-width: 767px) {
    .product-info-wrapper { order: 2 }
  }
`;
const ProductImageContainer = styled.div`
  width: 550px;
  height: 400px;
  display: flex;
  justify-content: center;
    align-items: flex-start;
  @media (max-width: 1100px) {
    width: 450px;
    height: 350px;
  }
  @media (max-width: 920px){
    width: 400px;
    height: 300px;
  }
  @media (max-width: 425px){
    width: 300px;
    height: 250px;
  }
`;

const ProductMainImage = styled.div`
  width: 400px;
  height: 400px;
    position: relative;

    .mainImage {
    max-height: 400px;
  }
  @media (max-width: 1100px) {
    width: 350px;
    height: 350px;
    .mainImage {
      max-height: 350px;
    }
  }
  @media (max-width: 920px){
    width: 300px;
    height: 300px;
    .mainImage {
      max-height: 300px;
    }
  }
  @media (max-width: 425px){
    width: 250px;
    height: 250px;
    .mainImage {
      max-height: 250px;
    }
  }
`;

const ZoomIconOverlay = styled.div`
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 5;

    svg {
        color: #666;
    }

    &:hover {
        background: #9cc54b;
        box-shadow: 0 4px 12px rgba(156, 197, 75, 0.3);

        svg {
            color: white;
        }
    }

    @media (max-width: 768px) {
        width: 32px;
        height: 32px;

        svg {
            width: 16px;
            height: 16px;
        }
    }
`;
const ProductImageSlider = styled.div`
  margin-right: 50px;
  overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
  ::-webkit-scrollbar {
      display: none;
  }
  @media (max-width: 1100px) {
    margin-right: 20px;
  }
  @media (max-width: 920px) {
    margin-right: 10px;
  }
  @media (max-width: 425px){
    margin-right: 0;
  }
`;

const ProductImageSliderItem = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  margin-right: 20px;
  border: 1px solid #e1e1e1;
  border-radius: 5px;

  img {
    border-radius: 5px;
    max-height: 95%;
  }
  @media (max-width: 1100px) {
    width: 60px;
    height: 60px;
  }
  @media (max-width: 920px) and (min-width: 767px) {
    width: 50px;
    height: 50px;
  }
  @media (max-width: 425px){
    width: 35px;
    height: 35px;
    margin-right: 15px;
  }
`;
const ProductPreview = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  padding: 30px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
    justify-content: flex-start;
  position: relative;

  @media (max-width: 767px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 30px 47px 40px 30px;
    order: 0;
  }

  .product-image-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-image {
    width: auto;
    max-width: 100% !important;
    @media (max-width: 767px) {
        width: auto;
        max-width: 95% !important;
    }
  }
  .active {
    border: 1px solid black;
  }
  img {
    width: 100%;
    height: auto;
    @media (max-width: 767px) {
      max-width: 300px !important;
    }
  }
`;

const SaleTag = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  background-color: ${themeGet("colors.yellow", "#FBB979")};
  padding: 0 10px;
  line-height: 24px;
  border-radius: 12px;
  display: inline-block;
  position: absolute;
  top: 40px;
  right: 30px;
`;

const DiscountPercent = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: #ffffff;
  line-height: 24px;
  background-color: ${themeGet("colors.yellow", "#FBB979")};
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
  display: inline-block;
  position: absolute;
  top: 30px;
  right: 30px;
  border-radius: 12px;
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);
`;

const ProductInfoWrapper = styled.div`
  vertical-align: bottom;
  flex: 0 0 50%;
  max-width: 50%;
    background: #ffffff;
    border-radius: 0 0 0 0;

    .productInfoTitle {
    font-size: 1.5rem;
        font-weight: 600;
        margin-bottom: 1rem;
        color: #2c3e50;
  }

  .bg-success {
    background-color: #9cc54b!important;
  }

  @media (max-width: 767px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 10px 0 30px;
    order: 1;
  }
`;

const ProductInfo = styled.div`
  padding: 30px;
  
  .availability {
    margin-top: 10px;
    padding-bottom: 0;
    
    p {
      font-size: 1rem;
      color: #999;
      margin-bottom: 10px;
    }
  }
  .stock-label {
    padding-right: 20px;
    color: #9cc54b;
    font-size: 1.2rem;
    
    &.out-of-stock {
      color: #FFAD5E;
    }
  }
  .review {
    color: #999;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .bg-warning { background-color: #f78205 !important; }

  @media (max-width: 767px) {
    padding: 0px 30px 30px 30px;
  }
`;

const ProductTitlePriceWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
`;

const ProductTitle = styled.h1`
  font-size: 1.8rem;
  font-family: "Lato", sans-serif;
  font-weight: 400;
`;

const ProductBrand = styled.h3`
  font-size: 1.4rem;
  font-family: "Arial Rounded Bold" !important;
  font-weight: 400;
  color: #9cc54b;
  margin-bottom: 10px;

  &:hover {
    cursor: pointer;
  }
`;

const PriceRow = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 8px;
`;

const PriceLeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
`;

const ProductPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  line-height: 1.2;
  margin-bottom: 0;
  margin-top: 0;
`;

const ProductPrice = styled.h2`
  font-family: "Lato", sans-serif;
  font-size: 2rem;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.primary", "#9cc54b")};
  margin: 0;

  &.strike-through {
    font-size: 1.5rem;
    color: #f78205 !important;
    text-decoration: line-through;
    margin-bottom: 2px;
  }
`;

export const PromoPrice = styled.span`
  font-family: "Lato", sans-serif;
  font-size: 2rem;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.primary", "#9cc54b")};
  display: inline-block;
  padding-left: 0;
`;

const SalePrice = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.yellow", "#FBB979")};
  font-style: italic;
  padding: 0 5px;
  overflow: hidden;
  position: relative;
  margin-right: 10px;

  &:before {
    content: "";
    width: 100%;
    height: 1px;
    display: inline-block;
    background-color: ${themeGet("colors.yellow", "#FBB979")};
    position: absolute;
    top: 50%;
    left: 0;
  }
`;

const ProductWeight = styled.div`
  font-family: "Lato", sans-serif;
  font-size: 1.3rem;
  color: ${themeGet("colors.darkRegular", "#77798c")};
  // margin-bottom: 20px;
`;

const ProductDescription = styled.p`
  font-family: "Lato", sans-serif;
  font-size: 1rem;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkMedium", "#424561")};
  line-height: 2;
  margin-top: 0px;
  .productInfoTitle {
    font-weight: bold;
  }
`;
const RedeemStepperWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #555;
  border-radius: 5px;
  height: 3rem;
  padding: 0 6px;
  gap: 4px;
  position: relative;

  .btn-redeem-left,
  .btn-redeem-right,
  .btn-redeem-info {
    background: none;
    border: none;
    outline: none;
    color: #fff;
    cursor: pointer;
    display: grid;
    place-content: center;
    padding: 4px 6px;
    transition: opacity 0.15s;

    &:hover { opacity: 0.75; }
    &:disabled { opacity: 0.4; cursor: not-allowed; }
  }

  .redeem-label {
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    white-space: nowrap;
    padding: 0 4px;
  }

  .redeem-info-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .redeem-tooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    right: 0;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 13px;
    color: #333;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    z-index: 10;
    line-height: 1.5;
  }
`;

const AddToCartStepper = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #9cc54b;
  border-radius: 5px;
  height: 3rem;
  padding: 0 6px;
  gap: 4px;
  min-width: 200px;

  .btn-cart-left,
  .btn-cart-right {
    background: none;
    border: none;
    outline: none;
    color: #fff;
    cursor: pointer;
    display: grid;
    place-content: center;
    padding: 4px 6px;
    transition: opacity 0.15s;

    &:hover { opacity: 0.75; }
    &:disabled { opacity: 0.4; cursor: not-allowed; }
  }

  .cart-qty {
    color: #fff;
    font-size: 1.5rem;
    font-weight: 700;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }
`;

const CartActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  .btn-redeem {
    background-color: #555;
    color: #fff;
    border: 1px solid #555;
    border-radius: 5px;
    font-weight: 500;
    font-size: 19px;
    height: 3rem;
    padding: 5px 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      background-color: #333;
      border-color: #333;
      color: #fff;
    }

    &:active,
    &:focus {
      box-shadow: 0 0 0 2px #555 !important;
      background-color: #333 !important;
      outline: 2px solid #555 !important;
      border-color: #333 !important;
      color: #fff !important;
    }
  }
`;

const ProductCartBtn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  
  .btn-success {
    background-color: #9cc54b;
    color: #fff;
    border: 1px solid #9cc54b;
    border-radius: 5px;
    font-weight: 500;
    font-size: 19px;
    height: 3rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 18px;

    &:hover {
      background-color: #7aaa2a;
      border-color: #7aaa2a;
      color: #fff;
    }

    &:active,
    &:focus {
      box-shadow: 0 0 0 2px #9cc54b !important;
      background-color: #7aaa2a !important;
      outline: 2px solid #9cc54b !important;
      border-color: #7aaa2a !important;
      color: #fff !important;
    }
  }

  .product-buy {
    font-weight: 700;
    font-size: 19px;
  }

  @media (max-width: 767px) {
    /* margin-top: 40px; */
  }

  .reusecore__button {
    font-family: "Lato", sans-serif;
    font-size: ${themeGet("fontSizes.2", "15")}px;
    font-weight: ${themeGet("fontWeights.6", "700")};
    color: ${themeGet("colors.primary", "#9cc54b")};
    height: 36px;
    border-radius: 4rem;
    width: 100%;
    max-width: 150px;

    .btn-icon {
      margin-right: 5px;
    }

    &:hover {
      color: #fff;
      background-color: ${themeGet("colors.primary", "#9cc54b")};
      border-color: ${themeGet("colors.primary", "#9cc54b")};
    }
  }
`;

const ProductCartWrapper = styled.div`
  display: flex;
  /* justify-content: center; */
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 0;
  margin-top: 10px;
  margin-bottom: 35px;

  @media (max-width: 767px) {
    margin-top: 40px;
  }
`;

const ProductMeta = styled.div`
  margin-top: 30px;
`;

const MetaSingle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const MetaItem = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: ${themeGet("colors.lightColor", "#f7f7f7")};
  padding: 0 15px;
  border-radius: 6px;
  cursor: pointer;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SaveBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: #f78205;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 2px 12px;
  border-radius: 20px;
  line-height: 24px;
  white-space: nowrap;
`;

const DeliPointsDealBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;

  .dp-deal-label {
    font-size: 13px;
    color: #666;
    margin-bottom: 2px;
  }

  .dp-deal-price {
    font-size: 2rem;
    font-weight: 700;
    color: #555;
  }
`;



const WaitingScreen = styled.div`
  position: fixed;
  top: 0;
  z-index: 1001;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);

  span.spinner-border {
    color: #9cc54b !important;
  }
  @media (min-width: 768px){
    span.spinner-border {
      height: 5rem;
      width: 5rem;
      border: 0.4em solid currentColor;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
  @media (min-width: 425px){
    span.spinner-border {
      height: 3.5rem;
      width: 3.5rem;
      border: 0.3em solid currentColor;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
`;

const ImageZoomModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.95);
    z-index: 10000;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-animation: fadeIn 0.3s ease;
    animation: fadeIn 0.3s ease;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: transparent;

    @-webkit-keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ZoomModalContent = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    cursor: default;
    pointer-events: none;
    padding: 80px 20px 120px;

    @media (max-width: 768px) {
        padding: 70px 15px 100px;
    }
`;

const ZoomedImageContainer = styled.div`
    width: 70vw;
    height: 100%;
    max-width: 1000px;
    min-width: 300px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    pointer-events: auto;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    @media (max-width: 1024px) {
        width: 80vw;
    }

    @media (max-width: 768px) {
        width: 90vw;
        min-width: 280px;
    }
`;

const ZoomedImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    -o-object-fit: contain;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    pointer-events: none;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    -moz-perspective: 1000;
    -ms-perspective: 1000;
    perspective: 1000;
    will-change: transform;

    &.transitioning {
        -webkit-transition: -webkit-transform 0.3s ease;
        -moz-transition: -moz-transform 0.3s ease;
        -o-transition: -o-transform 0.3s ease;
        transition: transform 0.3s ease;
        transition: transform 0.3s ease, -webkit-transform 0.3s ease, -moz-transform 0.3s ease, -o-transform 0.3s ease;
    }
`;

const CloseZoomButton = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.15);
    border: none;
    color: white;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    cursor: pointer;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    z-index: 10;
    pointer-events: auto;

    &:hover {
        background: rgba(156, 197, 75, 0.9);
        -webkit-transform: rotate(90deg) scale(1.1);
        -ms-transform: rotate(90deg) scale(1.1);
        transform: rotate(90deg) scale(1.1);
    }

    svg {
        pointer-events: none;
    }

    @media (max-width: 768px) {
        width: 40px;
        height: 40px;
        top: 15px;
        right: 15px;

        svg {
            width: 24px;
            height: 24px;
        }
    }
`;

const ZoomNavButton = styled.button`
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.15);
    border: none;
    color: white;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    cursor: pointer;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    z-index: 10;
    pointer-events: auto;

    &.prev {
        left: 30px;
    }

    &.next {
        right: 30px;
    }

    &:hover {
        background: rgba(156, 197, 75, 0.9);
        -webkit-transform: translateY(-50%) scale(1.15);
        -ms-transform: translateY(-50%) scale(1.15);
        transform: translateY(-50%) scale(1.15);
    }

    &:active {
        -webkit-transform: translateY(-50%) scale(0.95);
        -ms-transform: translateY(-50%) scale(0.95);
        transform: translateY(-50%) scale(0.95);
    }

    svg {
        pointer-events: none;
    }

    @media (max-width: 768px) {
        width: 44px;
        height: 44px;

        &.prev {
            left: 15px;
        }

        &.next {
            right: 15px;
        }

        svg {
            width: 20px;
            height: 20px;
        }
    }
`;

const ZoomControlsContainer = styled.div`
    position: absolute;
    bottom: 20px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    border-radius: 50px;
    padding: 12px 20px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    gap: 12px;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    -webkit-box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    z-index: 10;
    pointer-events: auto;

    @media (max-width: 768px) {
        bottom: 15px;
        padding: 10px 16px;
        gap: 8px;
    }
`;

const ZoomControlButton = styled.button`
    background: rgba(255, 255, 255, 0.15);
    border: none;
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        background: rgba(156, 197, 75, 0.9);
        -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transform: scale(1.1);
    }

    &:active:not(:disabled) {
        -webkit-transform: scale(0.95);
        -ms-transform: scale(0.95);
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }

    svg {
        pointer-events: none;
    }

    @media (max-width: 768px) {
        width: 36px;
        height: 36px;

        svg {
            width: 18px;
            height: 18px;
        }
    }
`;

const ZoomLevelIndicator = styled.div`
    color: white;
    font-size: 14px;
    font-weight: 600;
    min-width: 50px;
    text-align: center;
    user-select: none;

    @media (max-width: 768px) {
        font-size: 12px;
        min-width: 45px;
    }
`;

const ZoomImageCounter = styled.div`
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 10px 24px;
    border-radius: 25px;
    font-size: 15px;
    font-weight: 600;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    letter-spacing: 1px;
    z-index: 10;
    pointer-events: none;

    @media (max-width: 768px) {
        top: 15px;
        font-size: 13px;
        padding: 8px 20px;
    }
`;

const ZoomThumbnailStrip = styled.div`
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    background: rgba(0, 0, 0, 0.8);
    padding: 12px;
    border-radius: 16px;
    backdrop-filter: blur(10px);
    max-width: 90vw;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #9cc54b rgba(255, 255, 255, 0.2);
    z-index: 10;
    pointer-events: auto;

    &::-webkit-scrollbar {
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #9cc54b;
        border-radius: 10px;
    }

    @media (max-width: 768px) {
        bottom: 85px;
        gap: 8px;
        padding: 10px;
    }
`;

const ZoomThumbnail = styled.img`
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    border: 3px solid transparent;
    transition: all 0.3s ease;
    flex-shrink: 0;

    &:hover {
        border-color: rgba(156, 197, 75, 0.6);
        transform: scale(1.1);
    }

    &.active {
        border-color: #9cc54b;
        box-shadow: 0 0 0 3px rgba(156, 197, 75, 0.3);
        transform: scale(1.05);
    }

    @media (max-width: 768px) {
        width: 55px;
        height: 55px;
    }
`;

const EarnPromotionBadge = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 14px;
  color: #4b4b4bff;

  .promotion-text {
    font-weight: 500;
    padding-left: 10px;
    font-size: 16px;
  }
`;

const EarnPromotionTooltipWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  cursor: pointer;

  .info-icon {
    font-size: 23px;
    color: #999;
    transition: color 0.2s ease;
  }

  .tooltip-text {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    font-size: 13px;
    font-weight: 400;
    padding: 8px 12px;
    border-radius: 8px;
    max-width: 600px;
    min-width: 300px;
    white-space: normal;
    overflow-wrap: break-word;
    line-height: 1.4;
    z-index: 100;
    pointer-events: none;
    transition: opacity 0.2s ease, visibility 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 6px;
      border-style: solid;
      border-color: #333 transparent transparent transparent;
    }

    &.is-visible {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
  }
`;